import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';
import qs from 'qs';

export const query = gql`
  query GetSeriesAdmin($input: GetSeriesAdminInput!) {
    getSeriesAdmin(input: $input) {
      count
      counts {
        live
        active
        inactive
      }
      results {
        id
        logo
        name
        short_name
        website
        promoter_name
        promoter_email
        promoter_phone
        added_by
        active
        eventsCount
        type {
          id
          key
          value
        }
      }
    }
  }
`;
export default graphql(query, {
  options: (props) => {
    const search = qs.parse(props.location.search, { ignoreQueryPrefix: true });

    return {
      variables: { input: search },
      fetchPolicy: 'cache-and-network',
    };
  },
});
